import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(advancedFormat);

export const formatDate = (dateTime, format = "DD/MM/YYYY, HH:mm:ss") => {
  return dayjs(dateTime).format(format);
};
